import { render } from "./BancheECodiciConto.vue?vue&type=template&id=75f12d3e&scoped=true"
import script from "./BancheECodiciConto.vue?vue&type=script&lang=js"
export * from "./BancheECodiciConto.vue?vue&type=script&lang=js"

import "./BancheECodiciConto.vue?vue&type=style&index=0&id=75f12d3e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f12d3e"]])

export default __exports__